import { Connection } from '@solana/web3.js';
import { BigNum, LAMPORTS_EXP } from '@velocity-exchange/sdk';
import { NEW_ACCOUNT_DONATION } from '@velocity-exchange/common';

/**
 * Local mirror of `@velocity-exchange/common` rent helpers until that package
 * is published with `fetchAccountCreationRent`. Keep sizes in sync with:
 * - `User::SIZE` = 4496 (`programs/velocity/src/state/user.rs`)
 * - `SignedMsgUserOrders::space(8)` = 268
 */
export const USER_ACCOUNT_SIZE = 4496;

export function signedMsgUserOrdersSpace(numOrders: number): number {
	return 8 + 32 + 4 + 32 + numOrders * 24;
}

export const SWIFT_ACCOUNT_SIZE = signedMsgUserOrdersSpace(8);

export type AccountCreationRent = {
	userAccountRent: BigNum;
	swiftAccountRent: BigNum;
	baseCost: BigNum;
};

export async function fetchAccountCreationRent(
	connection: Connection
): Promise<AccountCreationRent> {
	const [userLamports, swiftLamports] = await Promise.all([
		connection.getMinimumBalanceForRentExemption(USER_ACCOUNT_SIZE),
		connection.getMinimumBalanceForRentExemption(SWIFT_ACCOUNT_SIZE),
	]);

	const userAccountRent = BigNum.from(userLamports, LAMPORTS_EXP);
	const swiftAccountRent = BigNum.from(swiftLamports, LAMPORTS_EXP);

	return {
		userAccountRent,
		swiftAccountRent,
		baseCost: userAccountRent.add(NEW_ACCOUNT_DONATION).add(swiftAccountRent),
	};
}
